import Animate from "./Animate";


const Title = (props) => {

  return (
      <div className='overflow-hidden'>
        {/*<h1 className={'sectionTitle mb-4 text-blue-300 dark:text-slate-500'}>*/}
        {/*<h1 className={'sectionTitle mb-4 text-blue-500 dark:text-rose-700'}>*/}
        <Animate direction='up' duration={0.6} delay={0.1} scrollTriggerStart='center bottom'>
          <h1 className={'sectionTitle mb-4 text-rose-500 dark:text-rose-700'}>
            {props.title}
          </h1>
        </Animate>
      </div>
  )
}

export default Title
